import React from "react";

function Popdle() {
    return (
        <div id="project" style={{ paddingBottom: 200 }}>
            <h1 id="projectHeader">Popdle</h1>
            <p id="projectSub"><i>React, TypeScript, Vite, Python, FastAPI, Postgres, TMDb API, Render</i></p>
            <p>
                Popdle is a daily pop-culture Wordle — guess the movie, TV show, or actor (sourced from TMDb) in six tries. I built it as a PLG/growth case study rather than just a game: it's a fully instrumented funnel with an onboarding A/B test, activation tracking, and a simulated premium paywall.
                <br></br><br></br>
                The goal was to mirror the responsibilities of a growth & monetization engineering role — full-stack feature delivery, experimentation infrastructure, and using data to drive activation and conversion, not just shipping gameplay.
            </p>
            <div>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/ambermichellelynn/popdle">Github</a>
                &nbsp;&nbsp;
                <a target="_blank" rel="noopener noreferrer" href="https://popdle-frontend.onrender.com/">Demo</a>
            </div>
            <br></br><br></br>
            <video controls style={{ width: "82.5%", borderRadius: 10, border: "1px #dcdee8 solid" }}>
                <source src="/videos/popdle-demo.mov" type="video/mp4" />
                Your browser doesn't support embedded video.
            </video>
            <br></br><br></br>
            <h3>Architecture</h3>
            <p>
                The frontend is React + TypeScript (Vite) — the game board, a stats/record page, and an onboarding flow with an A/B-tested variant. The backend is Python + FastAPI, handling game logic, daily word selection, event tracking, and a homegrown feature-flag/assignment service that stands in for a tool like LaunchDarkly or Eppo. Words are pulled from the TMDb API and filtered to clean single-word answers, with a curated fallback list for local development without an API key.
            </p>
            <br></br>
            <h3>Growth instrumentation</h3>
            <table>
                <tr>
                    <td style={{ paddingRight: 100 }}><li>Activation funnel: signup → game started → game won → paywall viewed → upgraded</li></td>
                    <td><li>Deterministic A/B assignment for onboarding (control vs. guided tutorial)</li></td>
                </tr>
                <tr>
                    <td style={{ paddingRight: 100 }}><li>Admin funnel dashboard with step-by-step conversion rates</li></td>
                    <td><li>Simulated trial-to-paid upgrade path via a subscriptions table and paywall modal</li></td>
                </tr>
            </table>
            <br></br><br></br>
            <p>
                Testing covers guess scoring (including duplicate-letter edge cases), game-over/validation rules, Premium archive/history gating, auth, and the Stripe test-mode checkout flow — including making sure a leaked simulated session id can't be redeemed by a different user.
            </p>
        </div>
    )
}

export default Popdle;
